const styles = (theme) => ({
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: theme.spacing(0, 4),
  },
  container: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: `${theme.shape.borderRadiusMedium}px`,
  },
  iconContainer: {
    height: '200px',
    minWidth: '40%',
    padding: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    borderRadius: `150px ${theme.shape.borderRadiusMedium}px ${theme.shape.borderRadiusMedium}px 150px`,
  },
  title: {
    ...theme.typography.h3,
    color: 'inherit',
    fontWeight: 500,
  },
  subtitle: {
    ...theme.typography.body1,
    color: 'inherit',
    fontWeight: 400,
    maxWidth: '80%',
  },
});

export default styles;
